import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../services/userService";
import { toast } from "react-toastify";

// Async thunks for password operations
export const forgotPassword = createAsyncThunk(
  "forgotPassword/forgotPassword",
  async (emailData, { rejectWithValue }) => {
    try {
      const response = await userService.forgotPassword(emailData);
      toast.success("Password reset email sent");
      return response.message;
    } catch (error) {
      toast.error(error.message || "Failed to send reset email");
      return rejectWithValue(error.message || "Failed to send reset email");
    }
  }
);

export const resetPassword = createAsyncThunk(
  "forgotPassword/resetPassword",
  async ({ token, passwords }, { rejectWithValue }) => {
    try {
      const response = await userService.resetPassword(token, passwords);
      toast.success("Password reset successfully");
      return response.success;
    } catch (error) {
      toast.error(error.message || "Failed to reset password");
      return rejectWithValue(error.message || "Failed to reset password");
    }
  }
);

// Initial state
const initialState = {
  loading: false,
  message: null,
  success: false,
  error: null,
};

// Forgot Password slice
const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Forgot Password
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.error = null;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.message = null;
      })
      // Reset Password
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { clearErrors, clearMessage } = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;

